import FormCheckbox from '../FormCheckbox';
import { useEffect, useRef, useState } from 'react';
import { getExistingFilterData } from '../../utils';
import { trackFilterSelection } from '../../utils/dataLayer';

export default function ToggleCheckboxFilter(props) {
  const [checked, setChecked] = useState(false);
  const isInitialRender = useRef(true);

  const handleChange = () => setChecked(prevChecked => !prevChecked);

  useEffect(() => {
    const existingValue = getExistingFilterData(props.fieldId, props.filters);

    if (existingValue && !checked) {
      setChecked(true);
    } else if (!existingValue && checked) {
      setChecked(false);
    }
  }, [props.filters, props.fieldId]);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    if (checked) {
      trackFilterSelection(props.fieldId, true);
      props.setFilter(props.fieldId, 'true');
    } else {
      trackFilterSelection(props.fieldId, false);
      props.removeFilter(props.fieldId);
    }
  }, [checked, props.fieldId]);

  return (
    <FormCheckbox
      checked={checked}
      id={props.id}
      label={props.label}
      onChange={handleChange}
      type="checkbox"
    />
  );
}
